import { TextField, InputAdornment, CircularProgress, Box, Typography, Grid } from "@mui/material";
import PasswordCritera from "../signUp/accountDetails/personalAccount/passwordCritera";
import { Info, Visibility, VisibilityOff } from "@mui/icons-material";
import logoDark from "../../../assets/images/signin/logoDark.png";
import useToggleState from "../../../hooks/useTogglePassword";
import { useSearchParams } from "react-router-dom";
import { useFormik } from "formik"; 
import { useState } from "react";
import Success from "./Success";
import "./forgot-password.scss";
import * as Yup from "yup";
import ApiClient from "helpers/ApiClient";
import GlobalSnackBar from "UI/snackbar/GlobalSnackBar";


const ConfirmPassword = () => {
  // ********************************* STATES ******************************
  const [circleProgress, setCircle] = useState(false);
  const [page4, setPage4] = useState(true);
  const [page5, setPage5] = useState(false);
  const [toggleSnackbar, setToggleSnackbar] = useState({ message: "", isToggle: false, mode: "" });
  const [loadingState, setLoadngState] = useState(false);
  let [searchParams, setSearchParams] = useSearchParams();


  let userData = JSON.parse(localStorage.getItem("userData") || sessionStorage.getItem("userData") || "null");

  // ******************************** Custom Hook ******************************
  const [state, toggleState]: any = useToggleState({
    password: false,
    confirmPassword: false,
    passCriteria: false,
  });
  // *********************************** Formik Validation schema ********************
  const validation = Yup.object().shape({
    password: Yup.string()
      .matches(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/, "Password criteria does not match")
      .required("New Password is required"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password")], "New password and confirm password does not match.")
      .required("Confirm Password is required"),
  });
  // *********************************** Formik initial schema ************************
  const initialSchema = {
    password: "",
    confirmPassword: "",
  };
  // *********************************** SUBMIT HANDLER ********************
  const forgotpasswordHandler = () => {

    setLoadngState(true)
    if (userData?.challengeName === "NEW_PASSWORD_REQUIRED") {
      ApiClient.post("users/reset-session", {
        email: userData?.userEmail,
        password: values?.confirmPassword,
        sessionToken: userData?.sessionToken
      })
        .then(() => {
          setLoadngState(false)
          setPage5(true);
          setPage4(false);
          setToggleSnackbar({
            message: "Check your email for verification",
            isToggle: true,
            mode: "success",
            // top: "110px",
          });
          let userDataFromStorageLocal = localStorage.getItem("userData") || "{}";
          userDataFromStorageLocal !== "{}"
            ? localStorage.removeItem("userData")
            : sessionStorage.removeItem("userData");
        })
        .catch(() => {
          setLoadngState(false)
        })
    }
    else {
      ApiClient.post("users/reset-password", {
        email: searchParams?.get("email"),
        newPassword: values?.confirmPassword,
        code: searchParams?.get("code")
      })
        .then(() => {
          setLoadngState(false)
          setPage5(true);
          setPage4(false);
        })
        .catch(() => {
          setLoadngState(false)
        })
    }
  }
  const { values, touched, errors, handleChange, handleBlur, handleSubmit } =
    useFormik({
      initialValues: initialSchema,
      validationSchema: validation,
      onSubmit: forgotpasswordHandler,
    });
  return (
    <div className={`forgot-password`} >
      {toggleSnackbar.isToggle && (
        <GlobalSnackBar setIsOpenSnack={setToggleSnackbar} isOpenSnack={toggleSnackbar} />
      )}
      <Grid container>
        {/* Forgot password banner image*/}
        <Grid item xl={8} md={6}>
          <Box className={`bg-banner-image`} sx={{ display: {}, }}></Box>
        </Grid>
        {/* Forgot password main layout*/}
        <Grid item xl={4} md={6} xs={12} sx={{ backgroundColor: "#f0f3fb", px: '4.16vw' }}>
          <Box sx={{ height: { md: '100vh', xs: 'auto' } }}>
            <Box className="loginContainer" >
              <Box sx={{ textAlign: "center" }}>
                <img className="logoImg" src={logoDark} alt="ppcn_logo" />
              </Box>
              {page4 && (
                <div className={`loginForm`} style={{ justifyContent: 'center' }}>
                  <form onSubmit={handleSubmit}>
                    <Typography fontSize={{ xs: '30px', md: '40px' }} style={{ textAlign: "center" }}>
                      <span className="grey-color fw-500">Create New password</span>
                    </Typography>
                    <Box className="w-80">
                      <Box sx={{ textAlign: "left", mt: 5 }}>
                        <Box component="div" sx={{ position: 'relative' }}>
                          <label className={errors.password && touched.password ? "error-color" : "label-color"}>New password <span style={{ color: 'red' }}>*</span></label>
                          {/* password criteria popup */}
                          <TextField
                            name="password"
                            type={state.password ? "text" : "password"}
                            sx={{ background: "#fff", mt: 0.5 }}
                            fullWidth
                            variant="outlined"
                            error={!!(errors.password && touched.password)}
                            value={values.password}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            onFocus={() => toggleState('showCriteria')}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  {state.password ? (
                                    <Visibility
                                      sx={{ cursor: "pointer" }}
                                      fontSize="medium"
                                      onClick={() => toggleState("Password")}
                                    />
                                  ) : (
                                    <VisibilityOff sx={{ cursor: "pointer" }} fontSize="medium" onClick={() => toggleState("Password")} />
                                  )}
                                  {errors.password && touched.password && (
                                    <Info sx={{ color: "#DC3545" }} fontSize="medium" />
                                  )}
                                </InputAdornment>
                              ),
                            }}
                          />
                          {state.passCriteria && (<PasswordCritera value={values.password} name="passCriteria" />)}
                          {errors.password && touched.password && (
                            <small className="error-color fs-14"> {errors.password} </small>
                          )}
                        </Box>
                      </Box>
                      <Box sx={{ textAlign: "left", mt: 5 }}>
                        <Box component="div">
                          <label className={errors.confirmPassword && touched.confirmPassword ? "error-color" : "label-color"}>Confirm password <span style={{ color: 'red' }}>*</span></label>
                          <TextField
                            name="confirmPassword"
                            type={state.confirmPassword ? "text" : "password"}
                            sx={{ background: "#fff", mt: 0.5 }}
                            fullWidth
                            variant="outlined"
                            error={!!(errors.confirmPassword && touched.confirmPassword)}
                            value={values.confirmPassword}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            onFocus={() => toggleState("hideCriteria")}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  {state.confirmPassword ? (
                                    <Visibility
                                      sx={{ cursor: "pointer" }}
                                      fontSize="medium"
                                      onClick={() => toggleState("confirmPassword")}
                                    />
                                  ) : (
                                    <VisibilityOff
                                      sx={{ cursor: "pointer" }}
                                      fontSize="medium"
                                      onClick={() => toggleState("confirmPassword")}
                                    />
                                  )}
                                  {errors.confirmPassword && touched.confirmPassword && (
                                    <Info sx={{ color: "#DC3545" }} fontSize="medium" />
                                  )}
                                </InputAdornment>
                              ),
                            }}
                          />
                          {errors.confirmPassword && touched.confirmPassword && (
                            <small className="error-color fs-14"> {errors.confirmPassword}</small>
                          )}
                        </Box>
                      </Box>
                      {/* ****************************************** BUTTON  ************************************* */}
                      <Box sx={{ mt: 6 }}>
                        <button type="submit" className="forgot-btn btn-primary cursor-pointer" >
                          {circleProgress &&
                            touched.password &&
                            touched.confirmPassword && (
                              <CircularProgress size={20} sx={{ color: "white" }} />
                            )}
                          {loadingState ? (
                            <>
                              <CircularProgress size={20} sx={{ color: "#FFFFFF", mr: 1 }} />
                              <span>{"  "} Loading...</span>
                            </>
                          ) : (
                            <span>CHANGE PASSWORD</span>
                          )}
                        </button>
                      </Box>
                    </Box>
                  </form>
                </div>
              )}
              {/* After creating new password in forgot password */}
              {page5 && <Success></Success>}

            </Box>
          </Box>

        </Grid>
      </Grid>

      {/* Before creating new password in forgot password */}


    </div>


  );
};
export default ConfirmPassword;